import { createAction } from "@reduxjs/toolkit";
import { AuthorizedUser } from "models/auth";

import { loginDone, logoutDone, setLoggingOutFlag, startLogin } from "./authSlice";

interface LoginPayload {
  shouldResetUser?: boolean;
  successCallback: Function;
  token: string;
}

interface AuthState {
  authUser: AuthorizedUser | null;
  loading: boolean;
  error: Error | null | unknown;
  isLoggingOut: boolean;
}

interface LoginDonePayload {
  authUser?: AuthorizedUser;
  error?: Error | unknown;
  isLoginOverride?: boolean;
}

const login = createAction<LoginPayload>("auth/login");
const exitImpersonation = createAction<any>("auth/exitImpersonation");
const loginWithCookie = createAction<LoginPayload>("auth/loginWithCookie");
const logout = createAction<LoginPayload>("auth/logout");

export {
  AuthState,
  exitImpersonation,
  login,
  loginDone,
  LoginDonePayload,
  LoginPayload,
  loginWithCookie,
  logout,
  logoutDone,
  setLoggingOutFlag,
  startLogin,
};
